import { AuthContext } from '@/context/contexts'
import { useContext } from 'react'

export const useAuth = () => {
  return useContext(AuthContext)
}
